export enum HeaderFilter {
  Filter = 'Filter',
  Module = 'Module',
  SubModule = 'SubModule',
}
